import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import AddCart from '@/components/common/AddCartNew';
import { AddToCartReferType } from '@/constants/track';
import { StatusEnum } from '@/types/cart';

import { ProductCardProps } from './';
import CardBody from './cardBody';
import CardHead from './cardHead';
import styles from './horizontalCardInner.module.scss';
import WeeklySold from './weeklySold';

export const soldOutStatus = [StatusEnum?.sold_out as string];

const HorizontalCardInner: React.FC<Partial<ProductCardProps>> = props => {
  const {
    data,
    addCartParams,
    children,
    showAddBtn = true,
    preSell,
    onATC,
    produtLink,
    showLeft = true,
    className,
    cardHeadCls,
    addCartCls,
    trackDataInDialog,
    showExtraTag,
    fetchYouMayLike
  } = props;

  //如果是直邮商品, referType全部改为pantry
  if (data.is_pantry) {
    addCartParams.referType = AddToCartReferType.pantry;
  }

  const { t } = useTranslation('common');

  const addCartCode = () => {
    return (
      <div onClick={e => e.stopPropagation()}>
        {data?.category === 'bundle' || data?.is_hotdish === 'Y' ? (
          <div className={classNames(styles.btnView, styles.btns, addCartCls)}>
            <span>{t('btn_view')}</span>
          </div>
        ) : showAddBtn ? (
          <div className={classNames(styles.btnsContainer, styles.btns, addCartCls)}>
            <div
              className={styles.addWrap}
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
              }}>
              <AddCart
                {...addCartParams}
                preSell={preSell}
                data={data}
                link={produtLink?.to}
                onNumChange={onATC}
                isInProductCard
                trackDataInDialog={trackDataInDialog}
                fetchYouMayLike={fetchYouMayLike}
              />
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  };

  return (
    <div className={classNames(classNames(styles.itemBox, styles.horizontal, className))}>
      <div className={styles.itemInfo}>
        <CardHead {...props} className={cardHeadCls}>
          <div className={styles.weeklySold}>
            <WeeklySold data={data} />
          </div>
        </CardHead>
        <CardBody
          {...props}
          showWeekly={false}
          showActivity={true}
          showLeft={showLeft}
          showBrandName={true}
          showExtraTag={showExtraTag}
        />
        {addCartCode()}
      </div>
      <div
        className={styles.childBox}
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
        }}>
        {children}
      </div>
    </div>
  );
};

export default HorizontalCardInner;
